import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { ChatBotComponent } from './chat.component';
import { ChatBotRoutingModule } from './chat.routing.module';
import { MaterialModule } from 'src/app/shared/material.module';
import { ComponentsModule } from 'src/app/shared/components/components.module';


@NgModule({
  declarations: [
    ChatBotComponent,
  ],
  imports: [
    CommonModule,
    ChatBotRoutingModule,
    MaterialModule,
    ComponentsModule
  ]
})
export class ChatBotModule { }
